import Vue from "vue";
import Vuex from "vuex";
import 'es6-promise/auto';
import menu from './modules/menu';
import auth from './modules/auth';
import app from './modules/app';
import msg from './modules/msg';
import mail from './modules/mail';
import kb from './modules/kb';
import chat from './modules/chat';
import media from './modules/media';
import fitting from './modules/fitting';

Vue.use(Vuex);

//const debug = process.env.NODE_ENV !== 'production'

export const store = new Vuex.Store({
    modules: {
        menu,
        auth,
        app,
        msg,
        mail,
        kb,
        chat,
        media,
        fitting
    },
    strict: false
});

export default store;

 